<template>
    <div class="container">
        <div class="section">
            <img class="img" :src="imgList[0]">
            <div class="activityBox" v-if="activity.isShow">
                <img class="activityImg" :src="activity.PCactiveImg">
            </div>
        </div>
        <div class="section">
            <img class="img" :src="titleImgList[0]">
        </div>
        <div class="sw-main">
            <div class="swiper-container current-wrap">
                <div class="swiper-wrapper">
                    <div v-for="item in pcSwiperList1" :key="item" class="swiper-slide">
                        <img :src="item" >
                    </div>
                </div>
                <div class="swiper-pagination current-pagination" />
                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
            </div>
        </div>
        <div class="section">
            <img class="img" :src="imgList[1]">
        </div>
        <div class="section">
            <img class="img" :src="titleImgList[1]">
        </div>
        <div class="tab-section">
            <div class="main">
                <div class="_tb">
                    <el-tabs v-model="activeName" @tab-click="changeTab">
                        <el-tab-pane class="main-tab" v-for="(item, index) in (tabMain.stageList || [])" :key="index" :label="item.stage" :name="index">
                            <div class="region">
                                <div class="m-title"><div class="tx">{{item.title}}</div> <div class="btn" @click="showModalFn(item)"></div></div>
                                <div class="m-icon"></div>
                                <div class="m-txt">
                                    <div class="m-left">
                                        <div class="l-title">学习目标</div>
                                        <div class="bor"></div>
                                        <div class="item" v-for="(v, i) in item.external.phaseTargetList" :key="i" >{{v}}</div>
                                    </div>
                                    <div class="m-right">
                                        <div class="l-title">关键技术点</div>
                                        <div class="bor"></div>
                                        <div class="item" :class="{'noicon':i == item.external.skillsList.length - 1}"  v-for="(v, i) in item.external.skillsList" :key="i" >{{v}}</div>
                                    </div>
                                </div>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>
                <div class="modal" v-if="showModal">
                    <img @click="close" class="close" src="https://s21.lgstatic.com/growth/activity/20210412/1618215171460.png">
                    <div class="m-txt">
                        <div class="m-left">
                            <div class="l-title">学习目标</div>
                            <div class="bor"></div>
                            <div class="item" v-for="(v, i) in showData.phaseTargetList" :key="i" >{{v}}</div>
                        </div>
                        <div class="m-right">
                            <div class="l-title">关键技术点</div>
                            <div class="bor"></div>
                            <div class="item" v-for="(v, i) in showData.skillsList" :key="i" >{{v}}</div>
                        </div>
                    </div>
                </div>
                <div class="tips-tab">
                    * 具体课程内容以实际课程安排和进度为准
                </div>
            </div>
        </div>
        <div class="section">
            <img class="img" :src="titleImgList[2]">
            <img class="img" :src="titleImgList[3]">
        </div>
        <div class="sw-main1">
            <div class="swiper-container wrap-current">
                <div class="swiper-wrapper">
                    <div v-for="item in pcSwiperList2" :key="item" class="swiper-slide">
                        <img :src="item" >
                    </div>
                </div>
                <div class="swiper-pagination currents-pagination" />
                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
            </div>

            <button class="btn-more" @click="JumpFn">
                <img :src="btnImgList.more">
            </button>
        </div>
        <div class="section">
            <img class="img" :src="titleImgList[4]">
        </div>
        <div class="section" v-for="(item, index) in imgList" :key="index">
            <img v-if="index >1" class="img" :src="item">
        </div>
        <!-- <button class="footer" @click="JumpFn">
            <img :src="btnImgList.footer">
        </button> -->
        <div class="footer">
          <template v-if="!showNew">
            <button v-if="isBView === 'A'" class="f-btn" @click="JumpFn"></button>
            <button v-if="isBView === 'B'" class="f-btn b" @click="JumpFn"></button>
            <div class="iconBox" v-if="activity.isShow">
                <img class="icon" :src="activity.PCicon">
            </div>
          </template>
          <template v-if="showNew">
            <button class="btn" @click="JumpFn()" >
                <div class="text-loop">
                  <TextLoop :userInfoList="userInfoList" v-if="userInfoList.length" />
                </div>
                  <img class="icon" src="https://s20.lgstatic.com/growth/activity/20210825/1629876405127.png" alt="">
            </button>
          </template>
        </div>

    </div>
</template>

<script>
import { handleJumpUrl } from '../../../uitl/getParam.js';
import List from './list'
import Swiper from 'swiper';
import activity from '../../../common/activity';
import 'swiper/dist/css/swiper.min.css';
import mixin from '../../../common/js/mixins/repurchase'

export default {
    mixins: [mixin],
    data() {
        return {
            activity,
            showModal:false,
            List,
            active: 0,
            imgList:[],
            titleImgList:[],
            pcSwiperList1:[],
            pcSwiperList2:[],
            tabMain:{},
            showData:{},
            btnImgList:{},
            courseId: 106,
        }
    },
    props: ['isBView'],
    mounted () {
        setTimeout(()=>{
          if(this.isAB) {
            this.eduPlatTrack('WebView', { page_id: '1s5n', page_from: '大课学习页'});
          } else {
            this.eduPlatTrack('WebView', { page_id: '1s5n'});
          }
        },500)
        let dataList = this.List.data.pc
        this.imgList = dataList.imgList
        this.titleImgList = dataList.titleImgList
        this.pcSwiperList1 = dataList.pcSwiperList1
        this.pcSwiperList2 = dataList.pcSwiperList2
        this.btnImgList = dataList.btnImgList

        this.tabMain = dataList.tabMain
        this.renderSwiper()
        this.renderSwiper1()
    },
    methods: {
        close() {
            this.showModal = false;
        },
        changeTab(val) {
            this.showModal = false
        },
        showModalFn(item) {
            this.showModal = true
            this.showData = item.inside
        },
        JumpFn() {
          if(this.showNew) {
            this.eduPlatTrack('WebButtonClick', {
                'page_id': '1s5n',
                'courses_id': [this.courseId+''],
                'button_name': '试学申请'
            });
          } else {
            this.eduPlatTrack('WebButtonClick', {
                'page_id': '1s5n',
                'button_name': this.isBView === 'B' ? '免费领取vip月卡' : '抢先领取试学名额'
            });
          }
            // let key = this.isBView === 'B' ? '0b0a6bf8c4d145fab1130a9cbbfa483a' : 'bbf380b5983e4f1993f71606a8f3b3e6';
            let key = 'bbf380b5983e4f1993f71606a8f3b3e6';
            handleJumpUrl(key);
        },
        renderSwiper() {
            setTimeout(() => {
                let modify = 0;
                let translate = 0;
                let scale = 0;
                const swiper = new Swiper('.current-wrap', {
                    autoplay: 3000,
                    loop: true,
                    slidesPerView: 'auto',
                    loopedSlides: 4,
                    pagination: '.current-pagination',
                    paginationClickable: true,
                    watchSlidesProgress: true,
                    prevButton: '.swiper-button-prev',
                    nextButton: '.swiper-button-next',
                    centeredSlides: true,
                    onSetTransition: (swiper, transition) => {
                        for (let i = 0; i < swiper.slides.length; i++) {
                            let slide = swiper.slides.eq(i);
                            slide.transition(transition);
                        }
                    },
                });
                swiper.on('progress', () => {
                    for (let i = 0; i < swiper.slides.length; i++) {
                        let slide = swiper.slides.eq(i);
                        let slideProgress = swiper.slides[i].progress;
                        modify = 1;
                        if (Math.abs(slideProgress) > 1) {
                            modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
                        }
                        translate = slideProgress * modify * 500 + 'PX';
                        scale = 1 - Math.abs(slideProgress) / 5;
                        let zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
                        slide.transform('translateX(' + translate + ') scale(' + scale + ')');
                        slide.css('zIndex', zIndex);
                    }
                });
            }, 500);
        },
        renderSwiper1() {
            setTimeout(() => {
                let modify = 0;
                let translate = 0;
                let scale = 0;
                const swiper = new Swiper('.wrap-current', {
                    autoplay: 3000,
                    loop: true,
                    slidesPerView: 'auto',
                    loopedSlides: 4,
                    pagination: '.currents-pagination',
                    paginationClickable: true,
                    watchSlidesProgress: true,
                    prevButton: '.swiper-button-prev',
                    nextButton: '.swiper-button-next',
                    centeredSlides: true,
                    onSetTransition: (swiper, transition) => {
                        for (let i = 0; i < swiper.slides.length; i++) {
                            let slide = swiper.slides.eq(i);
                            slide.transition(transition);
                        }
                    },
                });
                swiper.on('progress', () => {
                    for (let i = 0; i < swiper.slides.length; i++) {
                        let slide = swiper.slides.eq(i);
                        let slideProgress = swiper.slides[i].progress;
                        modify = 1;
                        if (Math.abs(slideProgress) > 1) {
                            modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
                        }
                        translate = slideProgress * modify * 620 + 'PX';
                        scale = 1 - Math.abs(slideProgress) / 5;
                        let zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
                        slide.transform('translateX(' + translate + ') scale(' + scale + ')');
                        slide.css('zIndex', zIndex);
                    }
                });
            }, 500);
        },
    },
}
</script>

<style lang="less" scoped>
.container {
    position: relative;
    width: 100%;
    background: #ECF5FF;
    padding-bottom: 120PX;
    .section {
        position: relative;
        width: 100%;
        min-width: 1200PX;
        .img {
            width: 100%;
            display: block;
        }
        .activityBox {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate(-50%);
            width: 950PX;
            height: 150PX;
        }
        .activityImg {
            display: block;
            float: right;
            width: 104PX;
            height: 133PX;
        }
    }
    .sw-main {
        position: relative;
        width: 100%;
        min-width: 1200PX;
        margin: 20PX 0 40PX;
        /deep/ .current-wrap {
            width: 1200PX;
            height: 600PX;
            .swiper-slide {
                width: 680PX;
                opacity: 0;
                img {
                    display: block;
                    width: 680PX;
                    margin: 0 auto;
                }
                &.swiper-slide-active {
                    opacity: 1;
                }
                &.swiper-slide-next, &.swiper-slide-prev {
                    opacity: .5;
                }
            }
            .swiper-pagination {
                bottom: 0PX;
            }
            .swiper-pagination-bullet{
                width: 10PX;
                height: 10PX;
                background: #9CC4FF;
                border-radius: 50%;
                opacity: 1;
                &-active{
                    border-radius: 10PX;
                    width: 22PX;
                    background: #3D8BFF;
                }
            }
            .swiper-button-prev {
                background: url('https://s21.lgstatic.com/growth/activity/20210423/1619159764473.png') no-repeat center;
                background-size: 100% 100%;
                width: 56PX;
                height: 56PX;
                top: 50%;
                transform: translateY(-50%);
                left: 0PX;
            }
            .swiper-button-next {
                background: url('https://s21.lgstatic.com/growth/activity/20210423/1619159850323.png') no-repeat center;
                background-size: 100% 100%;
                width: 56PX;
                height: 56PX;
                right: -80PX;
                top: 50%;
                transform: translateY(-50%);
                right: 0PX;
            }
        }
    }
    .tab-section {
        width: 100%;
        min-width: 1200PX;
        background-color: #C5E2FF;
        padding: 50PX 0;
        .main {
            position: relative;
            width: 1060PX;
            margin: 0 auto;
            padding-top: 1PX;
            .tab-title-img {
                position: absolute;
                top: 0;
                left: 0;
                display: block;
                width:100%;
            }
            ._tb {
                position: relative;
                margin: 0 auto;
                width: 1000PX;
                background-color: #fff;
                box-sizing: border-box;
                padding: 30PX 40PX;
                border-radius: 22px;
                /deep/ .el-tabs {
                    width: 100%;
                    .el-tabs__header, .el-tabs__nav-wrap, .el-tabs__nav-scroll, .el-tabs__nav {
                        height: 47PX;
                    }
                    .el-tabs__item {
                        line-height: 47PX;
                        text-align: center;
                        width: 150PX;
                        height: 47PX;
                        padding: 0;
                        font-size: 18PX;
                        font-family: SourceHanSansSC-Bold, SourceHanSansSC;
                        font-weight: 400;
                        color: rgba(50, 50, 50, 1);
                        margin: 0 17PX;
                    }
                    .el-tabs__nav-wrap::after{
                        background-color: transparent;
                    }
                    .el-tabs__active-bar {
                        background-color: transparent;
                    }
                    .el-tabs__item.is-active {
                        border-radius: 50PX;
                        padding: 0;
                        background: linear-gradient(50deg, #8086FF 0%, #40BBF0 100%);
                        color: #fff;
                    }
                }
                .region {
                    width: 100%;
                    padding-top: 20PX;
                    .m-title {
                        width: 100%;
                        height: 30PX;
                        position: relative;
                        font-size: 24PX;
                        color: #303032;
                        text-align: center;
                        font-family: Helvetica;
                        font-weight: normal;
                        .tx {
                            position: absolute;
                            top: 0PX;
                            left: 50%;
                            transform: translate(-50%);
                        }
                        .btn {
                            float: right;
                            width: 90PX;
                            height: 30PX;
                            background: url('https://s21.lgstatic.com/growth/activity/20210325/1616656811847.png') no-repeat;
                            background-size: 100% 100%;
                            margin-right: 40PX;
                        }
                    }
                    .m-icon {
                        margin: 8PX auto;
                        width: 688PX;
                        height: 2PX;
                        background: url('https://s21.lgstatic.com/growth/activity/20210402/1617345169076.png') no-repeat center;
                        background-size: 100% 100%;
                    }
                    .m-txt {
                        width: 100%;
                        display: flex;
                        margin-top: 30PX;
                        .m-left {
                            flex: 1;
                            box-sizing: border-box;
                            padding: 10PX 30PX;
                        }
                        .m-right {
                            width: 312PX;
                            box-sizing: border-box;
                            padding: 10PX 10PX;
                        }
                        .l-title {
                            font-size: 16PX;
                            font-family: Helvetica;
                            color: #36363C;
                        }
                        .bor {
                            width: 312PX;
                            height: 1PX;
                            margin: 16PX 0 20PX;
                            background-color: rgba(132, 132, 135, .4);
                        }
                        .item {
                            position: relative;
                            font-size: 14PX;
                            font-family: Helvetica;
                            color: #49494B;
                            padding-left: 15PX;
                            margin: 14PX 0;
                            &::after {
                                position: absolute;
                                content: '';
                                left: 0PX;
                                top: 8PX;
                                width: 4PX;
                                height: 4PX;
                                border-radius: 50%;
                                background: #6469A7;
                            }
                        }
                        .noicon {
                            &::after {
                                position: absolute;
                                content: '';
                                left: 0PX;
                                top: 8PX;
                                width: 4PX;
                                height: 4PX;
                                border-radius: 50%;
                                background: #fff;
                            }
                        }
                    }
                }
            }
            .modal {
                position: absolute;
                top: 160PX;
                left: 50%;
                transform: translate(-50%);
                width: 800PX;
                border-radius: 16PX;
                background-color: #fefefe;
                z-index: 999;
                border: 2PX solid #8086FF;
                box-sizing: border-box;
                padding: 20PX 50PX 40PX;
                .close {
                    position: absolute;
                    right: 14PX;
                    top: 14PX;
                    width: 40PX;
                    height: 40PX;
                }
                .m-txt {
                        width: 100%;
                        display: flex;
                        margin-top: 30PX;
                        .m-left {
                            flex: 1;
                            box-sizing: border-box;
                            padding: 10PX 30PX;
                        }
                        .m-right {
                            width: 312PX;
                            box-sizing: border-box;
                            padding: 10PX 10PX;
                        }
                        .l-title {
                            font-size: 16PX;
                            font-family: Helvetica;
                            color: #36363C;
                        }
                        .bor {
                            width: 312PX;
                            height: 1PX;
                            margin: 16PX 0 20PX;
                            background-color: rgba(132, 132, 135, .4);
                        }
                        .item {
                            position: relative;
                            font-size: 14PX;
                            font-family: Helvetica;
                            color: #49494B;
                            padding-left: 15PX;
                            margin: 14PX 0;
                            &::after {
                                position: absolute;
                                content: '';
                                left: 0PX;
                                top: 8PX;
                                width: 4PX;
                                height: 4PX;
                                border-radius: 50%;
                                background: #6469A7;
                            }
                        }
                    }
            }
            .tips-tab {
                font-size: 14PX;
                color: #666;
                position: absolute;
                bottom: 20PX;
                right: 80PX;
            }
        }
        @media screen and (max-width:1600px){
            .main {
                width: 900PX;
                ._tb {
                    width: 860PX;
                    /deep/ .el-tabs {
                        .el-tabs__item {
                            margin: 0 3PX;
                        }
                    }
                }
            }

        }

    }
    .sw-main1 {
        position: relative;
        width: 100%;
        min-width: 1200PX;
        margin: 20PX 0 40PX;
        /deep/ .wrap-current {
            width: 1200PX;
            height: 580PX;
            .swiper-slide {
                width: 780PX;
                opacity: 0;
                img {
                    display: block;
                    width: 780PX;
                    margin: 0 auto;
                }
                &.swiper-slide-active {
                    opacity: 1;
                }
                &.swiper-slide-next, &.swiper-slide-prev {
                    opacity: .5;
                }
            }
            .swiper-pagination {
                bottom: 0PX;
            }
            .swiper-pagination-bullet{
                width: 10PX;
                height: 10PX;
                background: #9CC4FF;
                border-radius: 50%;
                opacity: 1;
                &-active{
                    border-radius: 10PX;
                    width: 22PX;
                    background: #3D8BFF;
                }
            }
            .swiper-button-prev {
                background: url('https://s21.lgstatic.com/growth/activity/20210423/1619159764473.png') no-repeat center;
                background-size: 100% 100%;
                width: 56PX;
                height: 56PX;
                top: 50%;
                transform: translateY(-50%);
                left: 0PX;
            }
            .swiper-button-next {
                background: url('https://s21.lgstatic.com/growth/activity/20210423/1619159850323.png') no-repeat center;
                background-size: 100% 100%;
                width: 56PX;
                height: 56PX;
                right: -80PX;
                top: 50%;
                transform: translateY(-50%);
                right: 0PX;
            }
        }
        .btn-more {
            display: block;
            margin: 40PX auto 80PX;
            width: 488PX;
            height: 67PX;
            background-color:transparent;
            border: none;
            z-index: 9;
            img {
                width: 100%;
                display: block;
            }
        }
    }
    .footer {
        position: fixed;
        bottom: 0;
        width: 100%;
        // min-height: 120PX;
        min-width: 1200PX;
        left: 50%;
        transform: translate(-50%);
        z-index: 999;
        background-color: #fff;
        font-size: 0;
        .f-btn {
            width: 1200PX;
            height: 120PX;
            display: block;
            margin: 0 auto;
            background-color:transparent;
            background: url('https://s21.lgstatic.com/growth/activity/20210826/1629970883360.png?x-oss-process=style/80') no-repeat center;
            background-size: cover;
            border: none;
            &.b {
                background: url('https://s20.lgstatic.com/growth/activity/20220426/1650956661891.png') no-repeat center;
                background-size: cover;
            }
        }
        .iconBox {
            position: absolute;
            top: -30PX;
            left: 50%;
            transform: translate(-50%);
            z-index: 9999;
            width: 940PX;
            .icon {
                float: right;
                width: 134PX;
            }
        }
        .btn {
          width: 100%;
          font-size: 0;
          outline: none;
          border: none;
          img {
            width: 100%;
            object-fit: contain;
          }
        }
        .text-loop {
          position: absolute;
          width: 215PX;
          height: 37PX;
          right: 31.5%;
          top: 50%;
          transform: translateY(-50%);
          border: none;
          border-image-width: 0;
        }
    }
}



// https://s21.lgstatic.com/growth/activity/20210423/1619158403734.png
//
</style>
